import { baseDarkTheme } from '@luigiclaudio/ga-baseline-ui/base-theme';
import mailchimpSignUpTheme from './mailchimpSignUpTheme';
var mailchimpSignUpDarkTheme = {
  mailchimpSignUp: Object.assign({}, mailchimpSignUpTheme.mailchimpSignUp, {
    feature: {
      divider: {
        color: baseDarkTheme.base.grays.grayLighter
      }
    }
  })
};
export default mailchimpSignUpDarkTheme;